/**
 * Plugin for Vue to integrate an event bus system using mitt.
 * It provides a way to register and unregister event listeners in Vue components.
 * @param {import('vue').App} app - The Vue app instance.
 * @param {import('mitt').Emitter} eventBus - The event bus instance (mitt).
 */
export default (app, eventBus) => {
    app.mixin({
        /**
         * Vue lifecycle hook for component creation.
         * Registers event listeners defined in the component's `eventBusCallbacks` option.
         */
        created() {
            const callbacks = this.$options.eventBusCallbacks;
            if (callbacks) {
                for (let key in callbacks) {
                    eventBus.$on(key, this[callbacks[key]]);
                }
            }
        },

        /**
         * Vue lifecycle hook for component unmounting.
         * Unregisters event listeners defined in the component's `eventBusCallbacks` option.
         */
        unmounted() {
            const callbacks = this.$options.eventBusCallbacks;
            if (callbacks) {
                for (let key in callbacks) {
                    eventBus.$off(key, this[callbacks[key]]);
                }
            }
        }
    });
};
